import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  Divider,
  ListItem,
  ListItemText,
  Link,
  Grid,
  Button,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import Layout from "../layout/layout";
import {api}from "../services/api";
import ViewInArIcon from '@mui/icons-material/ViewInAr';

const ServicesExist = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [visibleResources, setVisibleResources] = useState({});
  const [loading, setLoading] = useState(true);

  const serviceCatelogue = localStorage.getItem('catalogueSelection');


  useEffect(() => {
    const fetchCategories = async () => {
      const cloudProviderId = localStorage.getItem('selectedProviderId');
      // let serviceId = localStorage.getItem('catalogueSelection');
  
      // if (serviceId === 'New') {
      //   serviceId = 1;
      // } else if (serviceId === 'existing') {
      //   serviceId = 2;
      // } else {
      //   console.error("Unexpected catalogueSelection value:", serviceId);
      //   return;
      // }
  
      setLoading(true);
      try {
        const response = await api.get(
          "/api/Application/popularServices",
          {
            params: {
              cloudProviderId: cloudProviderId,
              serviceId: 2,
              page: 1,
              pageSize: 10,
            }
          }
        );
  
        // Group services by category
        const groupedCategories = response.data.reduce((acc, service) => {
          const category = service.category;
  
          if (!acc[category]) {
            acc[category] = {
              categoryName: category,
              resources: [], // Ensure resources array is initialized
            };
          }
          acc[category].resources.push(service);
  
          return acc;
        }, {});
  
        const initialVisibleResources = Object.keys(groupedCategories).reduce((acc, categoryName) => {
          acc[categoryName] = 5; // Initially show 5 items per category
          return acc;
        }, {});
  
        setCategories(Object.values(groupedCategories));
        setVisibleResources(initialVisibleResources);
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchCategories();
  }, []);
  
  
  const handleResourceClick = (resourceId, resourceName) => {
    navigate("/Resources/View_Resources", { state: { resourceId, resourceName } });
  };

  const handleViewMore = (categoryID) => {
    setVisibleResources((prevVisibleResources) => ({
      ...prevVisibleResources,
      [categoryID]: prevVisibleResources[categoryID] + 5,
    }));
  };

  return (
    <Layout pageType="sideBar">
      <Box
        sx={{
          flex: 1,
          pl: 2,
          bgcolor: theme.palette.background.default,
          color: theme.palette.text.primary,
        }}
      >
        <Typography variant="body2" gutterBottom sx={{ marginTop: "20px", textTransform:'capitalize' }}>
          operational Resource
        </Typography>
        <Divider />
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Grid container spacing={2} alignItems="stretch">
  {categories.map((category) => (
    <Grid
      item
      
      key={category.categoryName}
      sx={{ display: "flex", flexDirection: "column",width:'32%' }}
    >
      <Paper
        sx={{
          p: 2,
          bgcolor: theme.palette.background.default,
          width: "100%",
          marginTop: "10px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          maxHeight: "300px", // Set a maximum height for scrolling: "300px",
           // Set a fixed height for uniformity
        }}
      >
        <Box
          sx={{
            borderBottom: "2px solid #2b61aa",
            px: 1,
            display: "inline-block",
            mb: 1,
          }}
        >
          <Link
            href="#"
            underline="hover"
            sx={{ color: theme.palette.text.primary, textTransform: 'capitalize' }}
          >
            <Typography variant="body2" gutterBottom>
              {category.categoryName}
            </Typography>
          </Link>
        </Box>
        <Grid container spacing={1} sx={{ flexDirection: "column", flexGrow: 1 }}>
          {category.resources
            .slice(0, visibleResources[category.categoryName] || 10)
            .map((resource) => (
              <Grid item xs={12} key={resource.resourceId}>
                <ListItem
                  button
                  onClick={() => handleResourceClick(resource.resourceId, resource.resourceName)}
                  sx={{
                    padding: "4px 8px",
                    display: "flex",
                    cursor: "pointer",
                    textTransform: "capitalize",
                    fontSize: '12px',
                    '&:hover': {
      bgcolor: '#2b61aa',          // Background color on hover
      '& .MuiTypography-root': {
        color: 'white',         // Text color on hover
      },
      '& .MuiSvgIcon-root': {
        color: 'white',         // Icon color on hover
      }
    }
                  }}
                >
                  <ViewInArIcon sx={{ mr: 2 }} />
                  <ListItemText primary={resource.resourceName} sx={{
                    '& .MuiTypography-root': {
                      fontSize: '12px'
                    }
                  }} />
                </ListItem>
              </Grid>
            ))}
        </Grid>
        {visibleResources[category.categoryName] < category.resources.length && (
          <Button
            onClick={() => handleViewMore(category.categoryName)}
            sx={{ mt: 2, color: "#2b61aa" }}
          >
            View More
          </Button>
        )}
      </Paper>
    </Grid>
  ))}
</Grid>


        )}
      </Box>
    </Layout>
  );
};

export default ServicesExist;
